export default __webpack_public_path__ + "static/media/IXT.1a6c634a.png";